<template>
  <el-table-column
    prop="name"
    sortable="custom"
    label="Hivatalos név"
    show-overflow-tooltip
    min-width="160"
    fixed
  >
    <template slot-scope="scope">
      {{ scope.row.company.name }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'name',
};
</script>
